import Head from 'next/head'
import Image from 'next/image'
import { Row, Col, CardTitle } from 'reactstrap'

export interface LayoutProps {
  children?: React.ReactNode
}

const LoginLayout = ({ children }: LayoutProps) => {
  return (
    <div>
      <Head>
        <link href="/1.svg" rel="icon" />
        <title key="page-title">Treload</title>

        <meta content="width=device-width, initial-scale=1.0" name="viewport" />
      </Head>
      <div className="auth-wrapper auth-cover">
        <Row className="auth-inner m-0">
          <Col className="d-none d-lg-flex align-items-center p-5" lg="8" sm="12">
            <div
              className="w-100 d-lg-flex align-items-center justify-content-center px-5 h-100"
              style={{
                position: 'relative',
                maxWidth: '100%',
                maxHeight: '100%',
              }}
            >
              <Image alt="Login Cover" className="img-fluid" layout="fill" objectFit="contain" src="/login-v2.svg" />
            </div>
          </Col>
          <Col className="d-flex align-items-center auth-bg px-2 p-lg-5" lg="4" sm="12">
            <Col className="px-xl-2 mx-auto" lg="12" md="6" sm="8" xs={12}>
              <CardTitle className="text-center">
                <Image alt="treload-logo" height={100} src="/2.svg" width={100} />
              </CardTitle>
              {children}
            </Col>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default LoginLayout
